import {combineReducers} from "redux";
import drawing from "./drawing";
import betting from "./betting";
import resultReport from "./resultReport";
import winloseReport from "./winloseReport";


const rouletteCombineReducer = combineReducers({
    drawing,
    betting,
    resultReport,
    winloseReport
});
export default rouletteCombineReducer;
